import { render, staticRenderFns } from "./DashboardPanel.vue?vue&type=template&id=675ddd28&scoped=true&"
import script from "./DashboardPanel.vue?vue&type=script&lang=js&"
export * from "./DashboardPanel.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPanel.vue?vue&type=style&index=0&id=675ddd28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ddd28",
  null
  
)

export default component.exports